import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import TbodyVivier from './components/tbody.vivier';
import ScrollableTableWrapper from '../../../../../../components/table/components/ScrollableTableWrapper';

const TableVivier = ({ users, setSortName, setAddVivier, sortName, list }) => {
  const [selectAll, setSelectAll] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const location = useLocation();

  // Synchroniser selectedId avec l'URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get('idTempWorker');
    if (id) {
      setSelectedId(id);
    }
  }, [location]);

  // Vérifiez si toutes les cases à cocher individuelles sont cochées, puis mettez à jour l'état de la case à cocher d'en-tête
  useEffect(() => {
    if (users && Array.isArray(users)) {
      if (list > 0) {
        const allChecked = users.every((user) => list.includes(user._id));
        setSelectAll(allChecked);
      }
    }
  }, [users, list]);

  const handleSortName = () => {
    setSortName((prevState) => !prevState);
  };

  const toggleSelectAll = () => {
    setSelectAll(!selectAll);
    // Mise à jour de la liste des ID en fonction de l'état de la case à cocher d'en-tête
    if (!selectAll) {
      // Si la case à cocher d'en-tête est cochée, ajouter tous les ID au tableau
      setAddVivier(users.map((user) => user._id));
    } else {
      // Sinon, supprimer tous les ID du tableau
      setAddVivier([]);
    }
  };

  return (
    <ScrollableTableWrapper>
      <table className="table-auto w-full text-gray-500 ft-sm">
        <thead className="sticky top-0 z-10">
          <tr className="sticky top-0 z-10 border-b border-gray-100">
            <th
              scope="col"
              className="sticky top-0 z-10 py-3.5 pl-4 md:pl-8 pr-2 font-medium text-left rtl:text-right text-sm text-gray-700 bg-gray-50 border-b border-gray-100 min-w-[280px]"
            >
              <div className="flex items-center gap-x-3">
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={() => toggleSelectAll()}
                />
                <span>CANDIDAT</span>
              </div>
            </th>
            <th
              scope="col"
              className="sticky top-0 z-10 py-3.5 px-2 text-left text-sm font-medium text-gray-700 bg-gray-50 border-b border-gray-100 min-w-[200px]"
            >
              CONTACT
            </th>
            <th
              scope="col"
              className="sticky top-0 z-10 py-3.5 px-2 text-left text-sm font-medium text-gray-700 bg-gray-50 border-b border-gray-100 min-w-[120px] max-w-[180px]"
            >
              VIVIER
            </th>
            <th
              scope="col"
              className="sticky top-0 z-10 py-3.5 pl-2 pr-4 md:pr-8 text-left text-sm font-medium text-gray-700 bg-gray-50 border-b border-gray-100 w-fit"
            ></th>
          </tr>
        </thead>
        <tbody>
          {users?.length > 0 &&
            users.map((user, key) => (
              <TbodyVivier
                key={key}
                champsBody={user}
                setAddVivier={setAddVivier}
                list={list}
                selectAll={selectAll}
                selectedId={selectedId}
                setSelectedId={setSelectedId}
              />
            ))}
        </tbody>
      </table>
    </ScrollableTableWrapper>
  );
};

export default TableVivier;
